import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // Path to your i18n.js file

export const wrapRootElement = ({ element }) => (
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
);

// Kod bazowy piksela w src/html.tsx wysyła PageView tylko przy pierwszym
// wejściu. Strona jest SPA, więc kolejne przejścia trzeba zgłosić ręcznie.
let isInitialRoute = true;

export const onRouteUpdate = () => {
  if (isInitialRoute) {
    isInitialRoute = false;
    return;
  }

  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
};
